import { ApiInstance } from '../api-instance';

interface IAggregatorCalcResponse {
    routes: {
        realPrice: number
        in: number
        allIn: number
        exchanges: {
            from: string
            to: string
            pool: string
            type: string
            amountIn: number
            amountOut: number
        }[]
    }[]
    aggregatedProfit: number
    estimatedOut: number
    priceImpact: number
    parameters: string
    actions: number
    datas: number
    error: string
}

interface IAvailableAssetsIdsResponse {
    success: boolean,
    availableAssetsIds: string[]
}

export class PuzzleSwapApi extends ApiInstance {
    calc(token0: string, token1: string, amountIn: number): Promise<IAggregatorCalcResponse> {
        return this.get(`/aggregator/calc`, {
            token0,
            token1,
            amountIn
        })
    }
    getAvailableAssetsIds(): Promise<IAvailableAssetsIdsResponse> {
        return this.get(`/aggregator/getAvailableAssetsIds`)
    }
}